import React, { useEffect, useState } from "react";
import { api, API } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Trash2, Upload, Copy } from "lucide-react";
import { toast } from "sonner";

export default function AdminImages() {
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/admin/images").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > 10 * 1024 * 1024) {
      toast.error(`Image is ${(file.size / 1024 / 1024).toFixed(1)}MB — max 10MB`);
      e.target.value = "";
      return;
    }
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("image", file); fd.append("caption", "");
      const token = localStorage.getItem("token");
      const res = await fetch(`${API}/admin/images`, { method: "POST", body: fd, credentials: "include", headers: token ? { Authorization: `Bearer ${token}` } : {} });
      if (!res.ok) {
        let detail = `Upload failed (HTTP ${res.status})`;
        try {
          const j = await res.json();
          if (j?.detail) detail = j.detail;
        } catch {
          try { const t = await res.text(); if (t) detail = t.slice(0, 200); } catch { /* ignore */ }
        }
        throw new Error(detail);
      }
      toast.success("Uploaded"); load();
    } catch (err) {
      toast.error(err?.message || "Upload failed");
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };

  const remove = async (id) => { if (!window.confirm("Delete image?")) return; await api.delete(`/admin/images/${id}`); load(); };
  const copy = (id) => { navigator.clipboard.writeText(`${API}/images/${id}`); toast.success("URL copied"); };

  return (
    <div data-testid="admin-images">
      <div className="flex items-end justify-between border-b border-border pb-4 mb-6">
        <div><h1 className="font-display text-4xl tracking-tight">Image library</h1>
          <p className="text-sm text-muted-foreground italic mt-1">Upload once, reuse in blog posts and pages.</p></div>
        <label className="bg-primary text-primary-foreground rounded-sm px-4 py-2 text-sm cursor-pointer hover:opacity-90 inline-flex items-center gap-2" data-testid="img-upload">
          <Upload className="h-4 w-4" strokeWidth={1.5} /> {busy ? "Uploading…" : "Upload image"}
          <input type="file" accept="image/*" onChange={upload} className="hidden" disabled={busy} />
        </label>
      </div>

      {items.length === 0 ? (
        <div className="text-center py-16 border border-dashed border-border rounded-sm text-sm text-muted-foreground italic">No images yet.</div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {items.map((img) => (
            <div key={img.id} className="border border-border rounded-sm bg-card overflow-hidden" data-testid={`img-${img.id}`}>
              <img src={`${API}/images/${img.id}`} alt={img.filename} className="w-full aspect-square object-cover" />
              <div className="p-2 flex items-center justify-between gap-2">
                <span className="text-xs truncate flex-1">{img.filename}</span>
                <Button variant="ghost" size="sm" onClick={() => copy(img.id)}><Copy className="h-3 w-3" strokeWidth={1.5} /></Button>
                <Button variant="ghost" size="sm" onClick={() => remove(img.id)}><Trash2 className="h-3 w-3" strokeWidth={1.5} /></Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
